[
  {
    "code": "AL-01",
    "name": "Berat"
  },
  {
    "code": "AL-09",
    "name": "Dibër"
  },
  {
    "code": "AL-02",
    "name": "Durrës"
  },
  {
    "code": "AL-03",
    "name": "Elbasan"
  },
  {
    "code": "AL-04",
    "name": "Fier"
  },
  {
    "code": "AL-05",
    "name": "Gjirokastër"
  },
  {
    "code": "AL-06",
    "name": "Korçë"
  },
  {
    "code": "AL-07",
    "name": "Kukës"
  },
  {
    "code": "AL-08",
    "name": "Lezhë"
  },
  {
    "code": "AL-10",
    "name": "Shkodër"
  },
  {
    "code": "AL-11",
    "name": "Tiranë"
  },
  {
    "code": "AL-12",
    "name": "Vlorë"
  }
]